<div class="p-6">
  @if (chargeInformation) {
    <app-card>
      <div class="flex gap-4">
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md font-semibold">
            {{ 'chargeInformation.navItems.overview' | translate }}
          </div>

          <app-value-details
            [collection]="chargeinformationDetailsData"
            [data]="chargeInformation"
          ></app-value-details>
        </div>
      </div>
    </app-card>
  }
</div>
